import { ISelectRow } from "../libs/dropdown/Dropdown"

export const Pages : (ISelectRow<string>&{tab:number})[] = [
    {label:"Home", value:"home", tab:0},
    {label:"Factsheet", value:"search", tab:1},
    {label:"Settings", value:"settings", tab:2},
]
export default class FoodUtils {
    static currentPage(path:string){
        const [_,page] = path.split("/")
        const current = Pages.find(p => p.value==page)
        return current || Pages[0]
    }
    static getTitle(path:string){
        return this.currentPage(path).label
    }
    static getPage(path:string){
        return this.currentPage(path).value
    }
    static get pages(){return Pages}
}